export enum QuestionType {
  QCU = 'QCU',
  QCM = 'QCM',
}
